// Human-friendly Song Processing references (owner UX 2026-07-21).
//
// Thin Processing-Job binding of the platform entity-reference standard in
// src/lib/entityRef.ts ("SP-0834E"; TR/AL/AR/RL/CH reserved for future
// surfaces). Kept so processing code reads domain language while the
// formatting/collision/search rules live in one place.

import {
  buildEntityRefs,
  formatEntityRef,
  normalizeRefSearchTerm,
} from "../../lib/entityRef";

/** Canonical short reference, e.g. "SP-0834E". */
export function formatJobRef(jobId: string, suffixLength?: number): string {
  return formatEntityRef("processingJob", jobId, suffixLength);
}

/**
 * Collision-safe refs for a rendered set of job ids. Non-colliding ids get
 * the standard 5-char ref; colliding groups are extended until unique.
 */
export function buildJobRefs(jobIds: readonly string[]): Map<string, string> {
  return buildEntityRefs("processingJob", jobIds);
}

/**
 * Search normalization: accepts "SP-0834E" (or the retired "PJ-0834E") or
 * any fragment of
 * the canonical id (see normalizeRefSearchTerm).
 */
export function normalizeJobSearchTerm(term: string): string {
  return normalizeRefSearchTerm("processingJob", term);
}
